// UI copy for the "Update Delivery Location" feature (DEV-2580 / DEV-4281).
// Kept out of the appConstants barrel so the strings sit with the feature that owns
// them, matching the per-feature constants convention (mapConstants, markerConstants…).

export const DIVERT_LABEL = 'Divert';
export const UPDATE_DELIVERY_LOCATION_TITLE = 'Update Delivery Location';
export const DELIVERY_LOCATION_SELECT_PLANT = 'Select a plant';
export const DELIVERY_LOCATION_ENTER_ADDRESS = 'Enter an address';
export const DELIVERY_LOCATION_PLANT_HINT = 'Search plants…';
export const DELIVERY_LOCATION_CONFIRM = 'Update the delivery location for this ticket?';
export const DELIVERY_LOCATION_UPDATE_SUCCESS = 'Delivery location updated.';
export const DELIVERY_LOCATION_UPDATE_ERROR = 'Unable to update the delivery location.';
export const DELIVERY_LOCATION_SELECT_MATCH = 'Select the matching address';
export const DELIVERY_LOCATION_SEARCHING = 'Searching addresses…';
export const DELIVERY_LOCATION_NO_MATCHES =
  'No matching addresses found. Try a more specific address.';
export const DELIVERY_LOCATION_LOOKUP_ERROR = 'Unable to look up that address. Please try another.';
export const DELIVERY_LOCATION_ADDRESS_PROMPT = 'Enter an address to see matching locations';

// DEV-4427: rows rendered in the plant Autocomplete. Sized to fill the modal's 300px
// scroll area rather than Autocomplete's 5-row default, which showed an arbitrary
// handful of a tenant-wide, all-product-line list.
export const DELIVERY_LOCATION_MAX_PLANT_SUGGESTIONS = 50;

export const DELIVERY_LOCATION_PLANT_LIST_RETRY = 'Retry';

// The optional diversion reason captured with a divert. `value` is the backend enum member
// name, which is what travels on the wire and is stored on the diversion record; `label` is
// what dispatchers see. The labels must match the DiversionReason descriptions in
// library-common so the dropdown and the diversion email read the same.
export const DIVERSION_REASON_LABEL = 'Reason for diversion (optional)';
export const DIVERSION_REASON_OTHER = 'Other';
export const DIVERSION_REASON_NOTES_PLACEHOLDER = 'Enter diversion notes';
// Mirrors the ticket_diversions.reason_notes column width; the backend truncates anything
// longer, so the field stops the user at the same bound.
export const DIVERSION_REASON_NOTES_MAX_LENGTH = 512;

export interface DiversionReasonOption {
  value: string;
  label: string;
}

export const DIVERSION_REASON_OPTIONS: DiversionReasonOption[] = [
  { value: 'CancelledPlantFull', label: 'Load cancelled - plant full' },
  { value: 'WrongMaterial', label: 'Wrong material' },
  { value: 'LoadRedirectedWhereNeededMost', label: 'Load redirected where needed most' },
  { value: 'PreLoadWithGenericAddress', label: 'Pre-load with generic address' },
  { value: DIVERSION_REASON_OTHER, label: DIVERSION_REASON_OTHER },
];
// The tenant-wide fetch is a single request made when the modal opens; until it lands
// the dropdown is legitimately empty, and saying so beats an unexplained blank list.
export const DELIVERY_LOCATION_PLANT_LOADING = 'Loading plants…';
